$(document).ready(function() {  
  /*===========================================================================================*/
  /* GET COOKIE FUNCTION                                                                       */
  /*===========================================================================================*/
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');

    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length,c.length);
      }
    }
    return "";
  }

  /*===========================================================================================*/
  // DECODE FILTER OBJECT   
  /*===========================================================================================*/
  // CHECK PAGE URL FOR FILTER OBJECT, BASE64 ENCODED. DECODE THE # ASND SEND THE FILTER RESULT BACK 
  function decodeURL() {
    var product_page_hash = window.location.hash;
    //console.log("HASH: " + product_page_hash);
    if(product_page_hash !== "" && product_page_hash !== undefined) {
      //TEST FOR PAGINATION
      var testPagination = product_page_hash.substring(5,-1);
      if (testPagination === "#page") {

      } else {  
        product_page_hash = product_page_hash.substring(1);
        product_page_hash = atob(product_page_hash);
        //console.log("DECODED HASH: " + product_page_hash);
        var Searchfilter = product_page_hash;
        return (Searchfilter); 
      }
    } else {
      return "";
    }

  }

  /*===========================================================================================*/
  // ENCODE FILTER OBJECT   
  /*===========================================================================================*/ 

  //EVERY TIME THIS FUNCTION IS CALLED WE NEED TO ENCODE THE FILTER OBJECT AND APPEND IT AS A # TO URL
  //THIS WILL ALOW An USER TO COPY THE PAGE URL AND OPEN IT ONE ANOTHER PC, BROWSER TAB AND IT WILL 
  //BRING UP THE SAME FILTER RESULTS
  function encodeURL(filterValue) {
    var searchURLencoded = btoa(JSON.stringify(filterValue));
    window.location.href = "#" + searchURLencoded;
  } 

  /*===========================================================================================*/
  /*  GET DEFAULT ITEMS PER PAGE OR USE COOKIE                                                 */
  /*===========================================================================================*/
  //CHECK IF COOKIE IS EMPTY
  var default_items_per_page_cookie = getCookie("default_items_per_page");
  if (default_items_per_page_cookie !== "" && default_items_per_page_cookie !== undefined) {
    var default_items_per_page = default_items_per_page_cookie;
  } else {
    var default_items_per_page = 16;
  }

  /*===========================================================================================*/
  /*  INITIALIZE GLOBAL VARIABLES                                                              */
  /*===========================================================================================*/
  var default_page_no = 1;
  var integrationURL = 'https://www.uconnectsecure.co.za/acdc/'; 
  var GETintegrationURL = 'https://www.uconnectsecure.co.za/getItemDiscount/';
  var product_page_url;
  var total_page_count;
  var html = "";
  var html_string_page = {};
  var totalPageCount;
  var alreadyFiltering = false;
  var dbname = getCookie('storeDB');
  var I = 0;
  var pagination_current_page = 1;
  var activeSearch = "false"; //BY DEFAULT WE ARE NOT DOING ANY SEARCHES, ACTIVE STATE IS FALSE
  var advancedSearchFilter;
  var MAXpriceLimit;
  var MinpriceLimit;
  var MAXpriceFilter;
  var MinpriceFilter;
  var freshload = true;
  var compareCount = 0;
  var compareArray = [];

  /*===============================================*/
  // CHECK IF CUSTOMER IS LOGGED IN OR NOT         */
  /*===============================================*/

  if ($(".customerACC").text() == ""){
    var customer = "WEBSITE";
  } else {
    var customer = $(".customerACC").text();
  }

  /*===========================================================================================*/
  /* MONEY FORMATING                                                                         */
  /*===========================================================================================*/
  function formatMoney(number, places, symbol, thousand, decimal) {
    places = !isNaN(places = Math.abs(places)) ? places : 2;

    symbol = symbol != undefined ? symbol : "R ";

    thousand = thousand || " ";
    decimal = decimal || ".";
    var   negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
  }  

  /*===========================================================================================*/
  /* REMOVE URL SPACES                                                                         */
  /*===========================================================================================*/
  // REMOVE ALL SPACES & SPECIAL CHARS FROM URL AND REPLACES WITH - 
  function removeURLspaces(space_url) {
    space_url = space_url.replace(/\-+ (?=)/g,'');
    space_url = space_url.replace(/^[-]/, "");
    space_url = space_url.replace('  ','-'); 
    space_url = space_url.replace(/ +(?= )/g,' ');
    space_url = space_url.replace(/ -+ (?=)/g,'-');
    space_url = space_url.replace(/ -\/+ (?=)/g,"-");
    space_url = space_url.replace(/%+(?=)/g,'');
    space_url = space_url.replace(/@+(?=)/g,'-');
    space_url = space_url.replace(/\.+\.+(?=)/g,'-');
    space_url = space_url.replace(/\.+ (?=)/g,'-');
    space_url = space_url.replace(/"\+"+ (?=)/g,'');
    space_url = space_url.replace(')+(','-');
    space_url = space_url.replace('(','');
    space_url = space_url.replace(')','');    
    space_url = space_url.replace(/\+ +(?=)/g,''); 
    space_url = space_url.replace(/ +\+(?=)/g,'-'); 
    space_url = space_url.replace(/ +\"(?=)/g,'');
    space_url = space_url.replace(/\"(?=)/g,'');
    space_url = space_url.replace(/\'(?=)/g,'');
    space_url = space_url.replace(/ +\/(?=)/g,'-');

    var no_space_URL = space_url.replace(/[^A-Z0-9]/ig, "-");
    return no_space_URL;
  }

  function removeSKUslash(space_url) {
    var removeSlash = space_url.replace(/\+(?=)/g,"_");
    removeSlash = space_url.replace(/\/+(?=)/g,"_");
    return removeSlash;
  }

  function removeIMGspaces(prodTitle) {
    var no_space_title = prodTitle.replace(/ +(?=)/g,'_'); 
    return no_space_title;
  }

  /*===========================================================================================*/
  /* REMOVE URL SLASHES                                                                        */
  /*===========================================================================================*/
  // REMOVE ALL SPACES & SPECIAL CHARS FROM URL AND REPLACES WITH - 
  function convertURLslash(slash_url) {
    var no_slash_URL = slash_url.replace(/\/+(?=)/g,'_');
    return no_slash_URL;
  }

  /*===========================================================================================*/
  /* REMOVE BRAND SPECIAL CHARS                                                                      */
  /*===========================================================================================*/
  // REMOVE ALL SPECIAL CHARS FROM BRANDS 
  function removeBrandchars(brand) {
    brand = brand.replace(/\/+(?=)/g,'');
    brand = brand.replace(/ +(?=)/g,'');
    return brand;
  }

  /*===========================================================================================*/
  /* PRODUCT IMAGE FUNCTIONS                                                                   */
  /*===========================================================================================*/
  //THIS FUNCTION MIGHT NOT BE APPLICABLE TO ACDC DYNAMICS
  function generateImageURL(size, code, color ) {
    return integrationURL + '/images/' + code + '/' + color; 
  }

  function lazyLoadImage(image) {
    image.attr('src','https://cdn.shopify.com/s/files/....'); //INSERT PRELOADING GIF URL
    var ds = image.attr('data-src');
    if(ds) {
      var img = $("<img />").attr('src', ds).on('load', function() {
        if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
          //alert('broken image!');
        } else {
          image.attr('src',ds);
        }
      });
    }
  }

  /*===========================================================================================*/
  /* PRICE SLIDER                                                                              */
  /*===========================================================================================*/
  //GET MIN AND MAX PRICE LIMITS
  /*
  function initPriceSlider(MinpriceLimit,MAXpriceLimit) {
    $(".range-slider").val(MinpriceLimit + "," + MAXpriceLimit);
    //INITIALIZE SLIDER    
    $('.range-slider').jRange({
      from: MinpriceLimit,
      to: MAXpriceLimit,
      step: 1,
      scale: [MinpriceLimit,MAXpriceLimit],
      format: '%s',
      width: 210,
      showLabels: false,
      isRange : true,
      theme: "theme-blue",
      showScale: false
    });  
  }
  MinpriceLimit = parseFloat(getCookie("MinpriceLimitCookie")).toFixed(2);
  MAXpriceLimit = parseFloat(getCookie("MaxpriceLimitCookie")).toFixed(2);
  initPriceSlider(MinpriceLimit,MAXpriceLimit);
  */

  /*===========================================================================================*/
  /*  PRODUCT FILTER                                                                           */
  /*===========================================================================================*/
  //THIS FUNCTION GENERATES A BLANK FILTER OBJECT. IF SEND TO SERVER IT WILL RETURN ALL PRODUCTS
  //SINCE NOTHING HAS BEEN SPECIFIED
  function initialiseFilter() {
    var marioSearchURL = window.location.pathname; 
    if (marioSearchURL === "/pages/mario-search") {
      $("#searchStartsWith").prop('checked', true);
      $(".searchStartsWith").addClass("radioOn");
      $(".searchStartsWith").removeClass("radioOff");
      $("#searchBoth").prop('checked', false); 
      $(".searchBoth").addClass("radioOff");
      $(".searchBoth").removeClass("radioOn");
      $("#searchSkuOnly").prop('checked', true); 
      $(".searchSkuOnly").addClass("radioOn");
      $(".searchSkuOnly").removeClass("radioOff");
      $("#searchContains").prop('checked', false); 
      $(".searchContains").addClass("radioOff");
      $(".searchContains").removeClass("radioOn");
      return {
        "category" : [],
        "brand" : [],
        "special" : [],
        "clearance" : [],
        "searchSKU" : "true",
        "searchDiscription" :"false",
        "contains" : "false",
        "startsWith" : "true",
        "orderBy" : "",
        "search" : "",
        "price": []
      }
    } else {
      $("#searchStartsWith").prop('checked', false); 
      $(".searchStartsWith").addClass("radioOff");
      $(".searchStartsWith").removeClass("radioOn");
      $("#searchBoth").prop('checked', true);
      $(".searchBoth").addClass("radioOn");
      $(".searchBoth").removeClass("radioOff");
      $("#searchSkuOnly").prop('checked', false); 
      $(".searchSkuOnly").addClass("radioOff");
      $(".searchSkuOnly").removeClass("radioOn");
      $("#searchContains").prop('checked', true);
      $(".searchBsearchContainsoth").addClass("radioOn");
      $(".searchBsearchContainsoth").removeClass("radioOff");
      return {
        "category" : [],
        "brand" : [],
        "special" : [],
        "clearance" : [],
        "searchSKU" : "false",
        "searchDiscription" :"false",
        "contains" : "true",
        "startsWith" : "false",
        "orderBy" : "",
        "search" : "",
        "price": []
      }
    }    
  }
  var filter = initialiseFilter();

  /*===========================================================================================*/
  /* IF COMING FROM BRANDS PAGE                                                                */
  /*===========================================================================================*/
  function checkCookieBrands() {
    var brandPageClick = getCookie("theBrand");
    if (brandPageClick.length == 0) {
    } else if (brandPageClick === "Default") {

    } else {
      filter.brand.push(brandPageClick);
    }
  } 
  checkCookieBrands();  

  /*===========================================================================================*/
  /* SWAP BETWEEN GRID VIEW AND LIST VIEW                                                      */
  /*===========================================================================================*/  
  $("#gridView").click(function(){
    $("#gridView").css("opacity","1");
    $("#listView").css("opacity","0.2");
    $(".long--one-fifth").each(function() {
      $(this).animate({width:"22%"});
      $(this).removeClass("long--one-fifth").addClass("wide--one-fifth");
    });
  });

  $("#listView").click(function(){
    $("#listView").css("opacity","1");
    $("#gridView").css("opacity","0.2");
    $(".wide--one-fifth").each(function() {
      $(this).animate({width:"100%"});
      $(this).removeClass("wide--one-fifth").addClass("long--one-fifth");
    });
  });

  /*===========================================================================================*/
  /*  LOAD PAGE CONTENT ACCORDING TO URL OR COOKIE                                        */
  /*===========================================================================================*/

  //GET CURRENT PAGE URL
  function GET_page_url(){
    product_page_url = window.location.pathname;   
    var specials_menu = "0";
    var brand_menu = "0";

    //CHECK URL
    switch (product_page_url) {
      case "/pages/products-specials":
        filter.special.push(1);
        $("#priceSpecial").prop('checked', true); 
        history.pushState(null, null, '/pages/all-products');
        encodeURL(filter);
        break; 
      case "/pages/products-clearance":
        filter.clearance.push(1);
        $("#priceClearance").prop('checked', true); 
        history.pushState(null, null, '/pages/all-products');
        encodeURL(filter);
        break; 
    }
    //IF WE ARE COMING FROM THE CATEGORY PAGE, CHECK WHAT CATEGORY WAS SELECTED
    var category_selection_cookie = getCookie("categorySelection");
    switch (category_selection_cookie) {
      case "ALL":
        filter.category.push("ALL");
        $('#ALL_input').prop('checked', true);  
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "AUT":
        filter.category.push("AUT");
        $('#AUT_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;    
      case "BC1":
        filter.category.push("BC1");
        $('#BC1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "BOB":
        filter.category.push("BOB");
        $('#BOB_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "CB1":
        filter.category.push("CB1");
        $('#CB1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "CO1":
        filter.category.push("CO1");
        $('#CO1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "CO2":
        filter.category.push("CO2");
        $('#CO2_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "COM":
        filter.category.push("COM");
        $('#COM_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "CON":
        filter.category.push("CON");
        $('#CON_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "DAT":
        filter.category.push("DAT");
        $('#DAT_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "DPM":
        filter.category.push("DPM");
        $('#DPM_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "DVS":
        filter.category.push("DVS");
        $('#DVS_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;         
      case "EES":
        filter.category.push("EES");
        $('#EES_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "ELC":
        filter.category.push("ELC");
        $('#ELC_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "ELT":
        filter.category.push("ELT");
        $('#ELT_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "EMP":
        filter.category.push("EMP");
        $('#EMP_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "ESP":
        filter.category.push("ESP");
        $('#ESP_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "ESP":
        filter.category.push("ESP");
        $('#ESP_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "ESP":
        filter.category.push("ESP");
        $('#ESP_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "FAN":
        filter.category.push("FAN");
        $('#FAN_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "FLP":
        filter.category.push("FLP");
        $('#FLP_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "GEN":
        filter.category.push("GEN");
        $('#GEN_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "GEW":
        filter.category.push("GEW");
        $('#GEW_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "GEWCB":
        filter.category.push("GEWCB");
        $('#GEWCB_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "GEWLIT":
        filter.category.push("GEWLIT");
        $('#GEWLIT_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "H":
        filter.category.push("H");
        $('#H_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
      case "HIG":
        filter.category.push("HIG");
        $('#HIG_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "HIG":
        filter.category.push("HIG");
        $('#HIG_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "L":
        filter.category.push("L");
        $('#L_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "LEG":
        filter.category.push("LEG");
        $('#LEG_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "LIT":
        filter.category.push("LIT");
        $('#LIT_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "M1":
        filter.category.push("M1");
        $('#M1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "MET":
        filter.category.push("MET");
        $('#MET_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "MOT":
        filter.category.push("MOT");
        $('#MOT_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "OR1":
        filter.category.push("OR1");
        $('#OR1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "P1":
        filter.category.push("P1");
        $('#P1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "P3":
        filter.category.push("P3");
        $('#P3_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "P4":
        filter.category.push("P4");
        $('#P4_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "PM":
        filter.category.push("PM");
        $('#PM_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "PRO":
        filter.category.push("PRO");
        $('#PRO_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "Q":
        filter.category.push("Q");
        $('#Q_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "R":
        filter.category.push("R");
        $('#R_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "RE1":
        filter.category.push("RE1");
        $('#RE1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "RHE":
        filter.category.push("RHE");
        $('#RHE_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "RHS":
        filter.category.push("RHS");
        $('#RHS_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "SCA":
        filter.category.push("SCA");
        $('#SCA_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "SEC":
        filter.category.push("SEC");
        $('#SEC_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "SM1":
        filter.category.push("SM1");
        $('#SM1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "SM2":
        filter.category.push("SM2");
        $('#SM2_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "SOL":
        filter.category.push("SOL");
        $('#SOL_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "SOL2":
        filter.category.push("SOL2");
        $('#SOL2_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "SOLSAV":
        filter.category.push("SOLSAV");
        $('#SOLSAV_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;  
      case "T":
        filter.category.push("T");
        $('#T_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "T1":
        filter.category.push("T1");
        $('#T1_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "T2":
        filter.category.push("T2");
        $('#T2_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "TC":
        filter.category.push("TC");
        $('#TC_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "TEC":
        filter.category.push("TEC");
        $('#TEC_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "TS":
        filter.category.push("TS");
        $('#TS_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "U":
        filter.category.push("U");
        $('#U_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "U2":
        filter.category.push("U2");
        $('#U2_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break;
      case "WIR":
        filter.category.push("WIR");
        $('#WIR_input').prop('checked', true); 
        document.cookie = "categorySelection=; path=/";
        encodeURL(filter);
        break; 
    }
  }
  GET_page_url();

  /*===========================================================================================*/
  /* PAGINATION                                                                                */
  /*===========================================================================================*/
  function pagiNATION(items_on_page,total_page_count,CURpage) {
    if(totalPageCount >= 1) {
      $("#PAGInation").pagination({
        pages: totalPageCount,
        itemsOnPage: items_on_page,
        displayedPages: 3,
        currentPage: CURpage,
        cssStyle: 'light-theme'
      });
    } else {

    }
  }

  /*===========================================================================================*/
  /* HEADER SEARCH BAR FUNCTIONS                                                               */
  /*===========================================================================================*/
  function TopSearchBar() {
    var topSearchBarValue_cookie = getCookie("TopSearchBarValue");
    if (topSearchBarValue_cookie !== "" && topSearchBarValue_cookie !== undefined){
      var newfilter = initialiseFilter();
      newfilter.search = topSearchBarValue_cookie;
      document.cookie = "TopSearchBarValue=; path=/;";
      //WE ARE PERFORMING AN ACTIVE SEACH, CHANGE ACTIVE SEARCH VAR TO TRUE
      activeSearch = "true";
      document.cookie = "activeSearchCookie=true; path=/";
      encodeURL(newfilter);
      return newfilter
    }
  }

  /*===========================================================================================*/
  /* ADD TO FAVOURITES FUNCTIONS                                                               */
  /*===========================================================================================*/  

  function favGetCookie() {
    var key,val,res;
    //get all cookie
    var oldCookie = document.cookie.split(';');
    for (var i = 0; i < oldCookie.length; i++) {
      key = oldCookie[i].substr(0,oldCookie[i].indexOf("="));
      val = oldCookie[i].substr(oldCookie[i].indexOf("=")+1);
      key = key.replace(/^\s+|\s+$/g,"");
      //find "user_cookie"
      if(key == "favItems") {
        res = val;
      }
    }
    if (res == undefined) {
      return null;
    } else {
      res = JSON.parse(res);
      return res.user;
    }
  } 

  function addToFAV() {
    var tempInit = favGetCookie();
    var str = JSON.stringify(tempInit);
    $(".wide--one-fifth").each(function() {
      $(this).find('.addToFav').click(function() {
        $(this).text("Added To Favourites");
        var theSKUFavInit = $(this).parent().parent().find('#variant').text();
        var arr = new Array();
        var obj = new Object();

        //add new cookie data
        obj.variant = theSKUFavInit;
        arr.push(obj);

        //get old cookie data
        var temp = favGetCookie();
        var str = JSON.stringify(temp);
        if (temp != null) {
          //concat new and old cookie data
          for (var i = 0; i < temp.length; i++) { 
            var ob = new Object();
            ob.variant = temp[i].variant;
            arr.push(ob);
          }
        }
        var objWarp = new Object();
        objWarp.user = arr;
        var val = JSON.stringify(objWarp);
        document.cookie = "favItems=" + val + '; expires=Fri, 31 Dec 9999 23:59:59 GMT"; path=/';
      });
      var theSKUFav = $(this).find('#variant').text();
      if (str.indexOf(theSKUFav) > 0) {    
        $(this).find('.addToFav').text("In Favourites");
        $(this).find('.addToFav').unbind('click');
      } else {
        $(this).find('.addToFav').text("Add To Favourites");
        $(this).find('.addToFav').bind('click');
      }
    });
  }

  /*===========================================================================================*/
  /* UPDATE FILTER CHECKBOXES FOR DECODE FILTER OBJECT                                         */
  /*===========================================================================================*/
  function UpdateFilterCheckBoxes(decodedFilter) {
    var brandCheckboxes = decodedFilter.brand.length;
    var catCheckboxes = decodedFilter.category.length;

    $(".activeFilterCatgories").empty();
    $(".activeFilterCatgories").append("<span class='selectedCatTitle'>Selected Categories: </span>");
    $(".activeFilterBrands").empty();
    $(".activeFilterBrands").append("<span class='selectedBrandTitle'>Selected Brands: </span>");

    //DO WE HAVE A BRANDS SELECTED
    //IF SO THEN DISPLAY THEM AT THE TOP
    //IF NOT HIDE BLOCK 
    if(brandCheckboxes > 0) {    
      for(var i = 0; i < brandCheckboxes; i++){
        var brandSpan = "<span class='SBblock SBrand" + i +"'></span>";
        $(".activeFilterBrands").append(brandSpan);    
      }
      $(".activeFilterBrands").show();
    } else {
      $(".activeFilterBrands").hide();    
    }

    //DO WE HAVE A CATEGORIES SELECTED
    //IF SO THEN DISPLAY THEM AT THE TOP
    //IF NOT HIDE BLOCK 
    if(catCheckboxes > 0) {    
      for(var i = 0; i < catCheckboxes; i++){
        var catSpan = "<span class='SCblock SCat" + i +"'></span>";
        $(".activeFilterCatgories").append(catSpan);    
      }
      $(".activeFilterCatgories").show();
    } else {
      $(".activeFilterCatgories").hide();    
    }

    var selectedBrands = "";
    for (var i = 0; i < brandCheckboxes; i++){

      $("#" + decodedFilter.brand[i] + "_input").prop("checked",true);
      $("#" + decodedFilter.brand[i] + "_input").siblings().addClass("radioOn");
      $("#" + decodedFilter.brand[i] + "_input").siblings().removeClass("radioOff");

      switch(decodedFilter.brand[i]) {
        case "ISK400":
          $(".SBrand" + i).text("ISKA");
          break;
        case "ISK401":
          $(".SBrand" + i).remove();
          break;   

        case "ACD300": 
          $(".SBrand" + i).text("RHOMBERG");
          break;
        case "ACD304":
          $(".SBrand" + i).remove();
          break;  

        case "TER400": 
          $(".SBrand" + i).text("TERASAKI");
          break;
        case "TER401":
          $(".SBrand" + i).remove();
          break;  

        case "UNI400": 
          $(".SBrand" + i).text("UNITRONICS");
          break;
        case "VIS300":
          $(".SBrand" + i).remove();
          break;  

        case "VAC400": 
          $(".SBrand" + i).text("VACON");
          break;
        case "VAC401":
          $(".SBrand" + i).remove();
          break;  
        case "VAC402":
          $(".SBrand" + i).remove();
          break;  

        default:
          var theBrand = $("#" + decodedFilter.brand[i] + "_input").siblings().text();
          $(".SBrand" + i).text(theBrand);

      }

    }
    var selectedCategories = "";
    for (var i = 0; i < catCheckboxes; i++){
      $("#" + decodedFilter.category[i] + "_input").parent().parent().parent().find(".catInfoTitle").css("color","#0070ba");
      $("#" + decodedFilter.category[i] + "_input").prop("checked",true);
      $("#" + decodedFilter.category[i] + "_input").siblings().addClass("radioOn");
      $("#" + decodedFilter.category[i] + "_input").siblings().removeClass("radioOff");  
      var theCat = $("#" + decodedFilter.category[i] + "_input").siblings().text();
      $(".SCat" + i).text(theCat);
    }

    if(catCheckboxes === 0){
      $(".catInfoTitle").css("color","#666");
    } 

    if(brandCheckboxes === 0){
      $(".catProdTabTitle").css("color","#666");
    } 
  }

  /*===========================================================================================*/
  /* PRELOAD BOXES FOR PRODCTS                                                                 */
  /*===========================================================================================*/
  function preloadBoxes(itemsCount) {
    for(var y = 0; y < itemsCount; y++) {
      var tabBlock = "<div class='orderedProduct SQ_" + y + "'></div>";
      //$("#indiAttack").addClass("SQ_" + y );
      $("#product_tab_container").append(tabBlock);
    } 
  }


  /*===========================================================================================*/
  /* FILTER DISPLAY SECTION AT THE TOP                                                         */
  /*===========================================================================================*/

  var criteriaA = $(".searchByReplace").text().toLowerCase();
  var criteriaB = $(".searchTermReplace").text().toLowerCase();
  var criteriaC = $(".searchIncludeReplace").text().toLowerCase();
  var searchTerm = $("#ProdSearch").val();

  $(".criteriaA").text(criteriaA).css("color","#0070ba");
  $(".criteriaB").text(criteriaB).css("color","#0070ba");
  $(".criteriaC").text(criteriaC).css("color","#0070ba");
  if(searchTerm === ""){
    $(".searchTerm").text("you have no search term").css("color", "red"); 
  } 

  function searchFilterDisplay() {
    var searchTerm = $("#ProdSearch").val();

    var criteriaA = $(".searchByReplace").text().toLowerCase();
    var criteriaB = $(".searchTermReplace").text().toLowerCase();
    var criteriaC = $(".searchIncludeReplace").text().toLowerCase();

    $(".criteriaA").text(criteriaA);
    $(".criteriaB").text(criteriaB);
    $(".criteriaC").text(criteriaC);
    $(".searchTerm").text(searchTerm).css("color", "#0070ba");   

    if(searchTerm === ""){
      $(".searchTerm").text("you have no search term").css("color", "red"); 
    }

    filter.search = searchTerm;
  }

  $("#ProdSearch").change(function() {
    $(".searchTerm").text($(this).val());
  });

  /*===========================================================================================*/
  /* PULL PRODUCT INFO DIRECTLY FROM ACDC-DYNAMICS SERVER                                      */
  /*===========================================================================================*/
  function productInfomation(pageno,itemsperpage,filter) { 
    //GET HASH FROM URL AND DECODE IT
    //IF WE HAVE HASH, UPDATE THE FILTER WITH THIS FILTER OBJECT
    //IF NOT, DO NOTHING
    var HAShash = decodeURL();   
    if(HAShash !== "" && HAShash !== undefined) {
      //console.log("HASH value: " + HAShash);
      var hashfilter = JSON.parse(HAShash);
      UpdateFilterCheckBoxes(hashfilter);
      filter = hashfilter;
    } else {
      UpdateFilterCheckBoxes(filter);
    }
    if (filter.searchSKU === "true") {
      $(".searchByReplace").text(" by item number");
      $(".criteriaA").text(" by item number");
      $(".searchByReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".searchDescriptionOnly").removeClass("radioOn");
      $(".searchBoth").removeClass("radioOn");
      $(".searchDescriptionOnly").addClass("radioOff");
      $(".searchBoth").addClass("radioOff");
    }

    if(filter.searchDiscription === "true") {
      $(".searchByReplace").text(" by item description ");
      $(".criteriaA").text(" by item description ");
      $(".searchByReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".searchSkuOnly").removeClass("radioOn");
      $(".searchBoth").removeClass("radioOn");
      $(".searchSkuOnly").addClass("radioOff");
      $(".searchBoth").addClass("radioOff");
    }

    if (filter.searchSKU === "false" && filter.searchDiscription === "false") {
      $(".searchByReplace").text(" by item number & item description");
      $(".searchByReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".searchDescriptionOnly").removeClass("radioOn");
      $(".searchSkuOnly").removeClass("radioOn");
      $(".searchDescriptionOnly").addClass("radioOff");
      $(".searchSkuOnly").addClass("radioOff");
    }

    if (filter.startsWith === "true") {
      $(".searchTermReplace").text(" that start with");
      $(".criteriaB").text(" that start with");
      $(".searchTermReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".searchContains").removeClass("radioOn");
      $(".searchContains").addClass("radioOff");
    }

    if (filter.contains === "true") {
      $(".searchTermReplace").text(" that contain");
      $(".criteriaB").text(" that contain");
      $(".searchTermReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".searchStartsWith").removeClass("radioOn");
      $(".searchStartsWith").addClass("radioOff");
    }

    if (filter.special === 1) {
      $(".searchIncludeReplace").text(" products on special only");
      $(".criteriaC").text(" products on special only");
      $(".searchIncludeReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".priceAll").removeClass("radioOn");
      $(".priceAll").addClass("radioOff");
      $(".priceClearance").removeClass("radioOn");
      $(".priceClearance").addClass("radioOff");
    }

    if (filter.clearance === 1) {
      $(".searchIncludeReplace").text(" products on clearance only");
      $(".criteriaC").text(" products on clearance only ");
      $(".searchIncludeReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".priceAll").removeClass("radioOn");
      $(".priceAll").addClass("radioOff");
      $(".priceSpecial").removeClass("radioOn");
      $(".priceSpecial").addClass("radioOff");
    }

    if(filter.search === ""){
      $(".searchTerm").text("you have no search term").css("color", "red"); 
    } else {
      $(".searchTerm").text(filter.search).css("color", "#0070ba");  
    }


    /*
    if (filter.clearance !== 1 && filter.special !== 1) {
      $(".searchIncludeReplace").text(" all products");
      $(".searchIncludeReplace").css("color","#0070ba");
      $(this).addClass("radioOn");
      $(this).removeClass("radioOff");
      $(".priceSpecial").removeClass("radioOn");
      $(".priceSpecial").addClass("radioOff");
      $(".priceClearance").removeClass("radioOn");
      $(".priceClearance").addClass("radioOff"); 
    }
*/

    //IF FILTER CONTAINS ANY BRAND OR CATEGORIES, UNCHECK THE VIEW ALL CHECKBOX
    var checkBrandBox = filter.brand;    
    if(checkBrandBox.length === 0) {
      $("#viewAllTab").find('#Dbi_title').addClass("radioOn");
      $("#viewAllTab").find('#Dbi_title').removeClass("radioOff");   
      $("#brandScript").find('.catProdTabTitle').css("color","#666");
    } else {
      $("#braProdTab").find('.catProdTabTitle').css("color","#0070ba");
      $("#viewAllTab").find('#Dbi_title').addClass("radioOff");
      $("#viewAllTab").find('#Dbi_title').removeClass("radioOn");
    }

    var checkCatBox = filter.category;    
    if(checkCatBox.length === 0) {
      $("#viewAllCatTab").find('#Dci_title').addClass("radioOn");
      $("#viewAllCatTab").find('#Dci_title').removeClass("radioOff"); 
      $("#catProdTab").find('.catProdTabTitle').css("color","#666");
    } else {
      $("#catProdTab").find('.catProdTabTitle').css("color","#0070ba");
      $("#viewAllCatTab").find('#Dci_title').addClass("radioOff");
      $("#viewAllCatTab").find('#Dci_title').removeClass("radioOn");
    }


    //IF FILTER CONTAINS SPECIALS OR CLEARANCE ADJUST PAGE TITLE    
    var ONspecial = filter.special;
    var ONclearance = filter.clearance;
    if(ONspecial.length !== 0){
      $(".ProductPageHeader").text("SPECIAL PRODUCTS");
      $("#specialsTab").find(".catProdTabTitle").addClass("activeTab");
      $("#clearanceTab").find(".catProdTabTitle").removeClass("activeTab");
    } else if (ONclearance.length !== 0) {
      $(".ProductPageHeader").text("CLEARANCE PRODUCTS");
      $("#specialsTab").find(".catProdTabTitle").removeClass("activeTab");
      $("#clearanceTab").find(".catProdTabTitle").addClass("activeTab");
    } else {
      $(".ProductPageHeader").text("ALL PRODUCTS");
      $("#specialsTab").find(".catProdTabTitle").removeClass("activeTab");
      $("#clearanceTab").find(".catProdTabTitle").removeClass("activeTab");
    }

    console.log("loading filter" + JSON.stringify(filter));

    //GET COOKIE FROM ITEMS PER PAGE DROP DOWN
    var IPP = getCookie("default_items_per_page");
    if (IPP != '' && IPP != undefined){
      itemsperpage = IPP;
    }

    //CHECK IF WE HAVE TOP SEARCHBAR SEARCH REQUEST
    var topSearchFilter = TopSearchBar();
    if (topSearchFilter !== '' && topSearchFilter!== undefined) {
      filter = topSearchFilter;
    };

    //PREVENT CHECKBOXES FROM BEEING CLICKED WHILE LAODING
    $('.openerCheck').attr('disabled', 'disabled'); 
    $('.loadingShadow').css("display","table-cell");

    var complete_url = integrationURL + 'products/search/' + itemsperpage + '/' + pageno;

    var starttime = Date.now();

    $.ajax({  
      url: complete_url,
      type: 'post',
      data: JSON.stringify(filter),
      headers: {
        "Content-Type" : 'application/json'
      },
      success: function (searchdata) {

        if (freshload) {
          //SAVE MIN AND MAX PRICE LIMITS ON PAGE LOAD
          //WE DO THIS TO ENSURE THAT WE HAVE MIN AND MAX ALL THE PRODUCT AND 
          //NOT JUST THE CURRENT SELECTION
          document.cookie = "MaxpriceLimitCookie=" + searchdata.maxPrice + "; path=/;";
          document.cookie = "MinpriceLimitCookie=" + searchdata.minPrice + "; path=/;";
          var MinpriceLimit = parseFloat(searchdata.minPrice).toFixed(2);
          var MAXpriceLimit = parseFloat(searchdata.maxPrice).toFixed(2);
        }

        //PAGE HAS ALREADY LOADED ONCE, CHANGE FRESHLOAD STATE TO FALSE TO PREVENT A DOUBLE LOAD
        freshload = false;       

        starttime = Date.now();            
        $('.openerCheck').removeAttr('disabled');
        $('.loadingShadow').css("display","none"); 
        var isFirstVariant = true;
        var firstVariantImageId = 0;
        var whichVariant = 0;

        totalPageCount = Math.ceil(searchdata.totalPageCount);
        var totalProducts = Math.ceil(searchdata.productItemCount);

        $(".totalProducts").text(totalProducts + " ITEMS");

        /*======================================*/
        /* RESULTS FEEDBACK TO USER             */
        /*======================================*/ 
        //DID WE GET ANY RESULTS BACK?
        if(totalPageCount <= 0){ 
          //NO WE DID NOT, CLEAR THE BLOCK AND HIDE PAGINATION
          $("#product_item_blocks").empty();
          $("#pagination_footer").hide();
          //WAS THIS AN ACTIVE SEARCH REQUEST?
          var activeSearchCookie = getCookie("activeSearchCookie");
          activeSearch = activeSearchCookie;
          if (activeSearch === "true") {
            //YES, DISPLAY NO RESULTS FOUND MESSAGE
            $("#NoResults").css("display","block");
            $("#result").css("display","block");
            $("#result").text("Please clear your filter before starting a new search.");

            //ON ADVANCED SEARCH USERS DONT ALWAYS INPUT A SEARCH CRITERIA, ONLY FILTER
            //THAT GIVES US A BLANK SEARCH WHICH WE DONT WANT  
            if(filter.search === "") {
              //DONT DISPLAY RESULT DIV
            } else {
              $("#result").text('"' + filter.search + '"');
            }
            document.cookie = "activeSearchCookie=false; path=/";

          } else {
            //NO, DISPLAY NORMAL NO RESULTS FOUND MESSAGE
            $("#result").css("display","block");
            $("#NoResults").css("display","block");
            $("#result").css("display","block");
            $("#result").text("Please clear your filter before starting a new search.");
          }
        } else{
          //YES WE DID, NORMAL NO RESULTS FOUND MESSAGE 
          $("#NoResults").css("display","none");
          $("#result").css("display","none");
          //WAS THIS AN ACTIVE SEARCH REQUEST?
          var activeSearchCookie = getCookie("activeSearchCookie");
          activeSearch = activeSearchCookie;
          if (activeSearch === "true") {
            //ON ADVANCED SEARCH USERS DONT ALWAYS INPUT A SEARCH CRITERIA, ONLY FILTER
            //THAT GIVES US A BLANK SEARCH WHICH WE DONT WANT  
            if(filter.search === "") {
              //DONT DISPLAY RESULT DIV
            } else {
              //YES, DISPLAY RESULTS FOUND MESSAGE
              $("#NoResults").css("top","0px");
              $("#NoResults").css("margin","0 auto");
              $("#result").css("margin","0 auto 20px auto");
              $("#result").css("top","0px");
              $("#NoResults").css("display","block");
              $("#NoResults").text('Results for search request : ');
              $("#result").css("display","block");
              $("#result").text('"' + filter.search + '"');
              document.cookie = "activeSearchCookie=false; path=/";
            }
          }
        }
        pagiNATION(itemsperpage,totalPageCount,pageno);

        $("#product_tab_container").empty();
        preloadBoxes(searchdata.sku.length);

        /*===========================================================================================*/
        /* PAGINATION                                                                                */
        /*===========================================================================================*/ 
        $(".page-link").on( "click", function() {
          if ($(this).hasClass('prev')){
            var page = parseInt(pagination_current_page) - 1;
            pagination_current_page = page;
          } else if ($(this).hasClass('next')){
            var page = parseInt(pagination_current_page) + 1;
            pagination_current_page = page;
          } else {
            var page = $(this).text();
            pagination_current_page = page; 
          }
          $('.loading-image-shodow').show();
          productInfomation(page, default_items_per_page, filter);
        });

        var counter = 0;
        var url_title = "";

        for(var i = 0; i < searchdata.sku.length; i++) {
          $.get(GETintegrationURL + customer + '/' + removeSKUslash(searchdata.sku[i])).done(function(data) {    
            if (data.options.length > 0) {
              for(var T = 0; T < data.options.length; T++) {
                if(data.options[T].OPTFIELD === "CERTLINK") {
                  if (data.options[T].VALUE === "http://storage-download.googleapis.com") {
                    /*
                    //MAKE ADJUSTMENTS TO CERT THAT DONT HAVE LINKS
                    debugger;
                      $(this).parent().addClass('noCert1');

                      //CERT HAS NO LINK, SHOW POPUP
                      $(this).parent().on("click", function(){
                        $(this).parent().removeAttr('target');
                        $(this).parent().removeAttr('href');
                        if($(this).hasClass('noCert1')){                          
                          $('.popOverlay').show();
                          $('.popText').show();
                          $('#techSpec').hide();
                          var sku = $('.product-info-code').text();
                          $('#IndiProdID').attr('value',sku);
                        }
                      });

                    //});
*/
                  } else {
                    var CertLink = data.options[T].VALUE;
                  }                  
                } 
                if(data.options[T].OPTFIELD === "SPECLINK") {
                  if (data.options[T].VALUE === "http://storage-download.googleapis.com") {
                    /*
                   // $('.TechBlock').each(function() {
                      $(this).parent().addClass('noCert2');
                      //CERT HAS NO LINK, SHOW POPUP
                      $(this).parent().on('click', function(){
                        if($(this).hasClass('noCert2')){
                        $(this).parent().removeAttr('target');
                        $(this).parent().removeAttr('href');
                          $('.popOverlay').show();
                          $('.popText').show();
                          $('#certSpec').hide();
                          var sku = $('.product-info-code').text();
                          $('#IndiProdID').attr('value',sku);
                        }
                      });
                    //});
*/
                  } else {
                    var SpecLink = data.options[T].VALUE;
                  }                  
                }
                if(data.options[T].OPTFIELD === "PICTURE") {
                  var PicLink = data.options[T].VALUE;
                } 

              }
            }

            var saving = data.price[0].Price * data.discount[0].Discount/100;
            var nettPrice = data.price[0].Price - saving;
            var listPrice = data.price[0].Price;

            if(data.salesPrice.length !== 0) {
              //CHECK TO SEE IF ANY SALES PRICES ARE RETURNED
              var nettPriceSaving = data.salesPrice[0].Price;
              var savingSpecial = data.price[0].Price - data.salesPrice[0].Price;

              //IF SPECIAL PRICE IS BIGGER THAN DISCOUNTED, DISPLAY SPECIAL PRICE
              if (savingSpecial > saving) {
                saving = formatMoney(savingSpecial, 2, 'R ', ' ', '.'); 
                nettPrice = formatMoney(nettPriceSaving, 2, 'R ', ' ', '.');
                listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');
              } else { 
                nettPrice = formatMoney(nettPrice, 2, 'R ', ' ', '.');  
                saving = formatMoney(saving, 2, 'R ', ' ', '.'); 
                listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');     
              }

            } else if (data.clearancePrice.length !== 0) {
              //CHECK TO IF ANY CLEARANCE PRICES ARE RETURNED

              var nettPriceSaving = data.clearancePrice[0].Price; 
              var savingSpecial = data.price[0].Price - data.clearancePrice[0].Price;

              //IF CLEARANCE PRICE IS BIGGER THAN DISCOUNTED, DISPLAY SPECIAL PRICE
              if (savingSpecial > saving) {
                saving = formatMoney(savingSpecial, 2, 'R ', ' ', '.'); 
                nettPrice = formatMoney(nettPriceSaving, 2, 'R ', ' ', '.');
                listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');
              } else { 
                nettPrice = formatMoney(nettPrice, 2, 'R ', ' ', '.');  
                saving = formatMoney(saving, 2, 'R ', ' ', '.'); 
                listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');     
              }

            } else { 
              nettPrice = formatMoney(nettPrice, 2, 'R ', ' ', '.');  
              saving = formatMoney(saving, 2, 'R ', ' ', '.'); 
              listPrice = formatMoney(data.price[0].Price, 2, 'R ', ' ', '.');     
            }

            /*===========================================================================================*/
            /*  SPECIAL AND CLEARANCE RIBBON FUNCTIONS                                                              */
            /*===========================================================================================*/
            function displayRibbons() {
              //IF PRODUCT HAS A SALES PRICE, DISPLAY RIBBON
              if(data.salesPrice.length !== 0) {
                $(".specRib").css("display","block");                     
              } else {
                $(".specRib").css("display","none"); 
              } 

              //IF PRODUCT HAS A CLEARANCE PRICE, DISPLAY RIBBON
              if (data.clearancePrice.length !== 0) {
                $(".clearRib").show(); 
              } else {
                $(".clearRib").hide(); 
              }              
            }

            /*===========================================================================================*/
            /*  BROKEN PRODUCT IMAGE CHECK                                                               */
            /*===========================================================================================*/
            //IF A PRODUCT HAS A BROKEN IMAGE WE NEED TO REPLACE IT WITH THE CATEGORY IMAGE

            switch(data.price[0].Category) {
              case "ALL":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ALL.png?13999154437255759986";
                break;
              case "AUT":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/AUT.png?13999154437255759986";
                break;
              case "BC1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/BC1.png?13999154437255759986";
                break;
              case "BOB":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/BOB.png?13999154437255759986";
                break;
              case "CB1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CB1.png?13999154437255759986";
                break;
              case "CO1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CO1.png?13999154437255759986";
                break;
              case "CO2":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CO2.png?13999154437255759986";
                break;
              case "COM":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/COM.png?13999154437255759986";
                break;
              case "CON":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CON.png?13999154437255759986";
                break;
              case "ELT":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ELT.png?13999154437255759986";
                break;
              case "EMP":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/EMP.png?13999154437255759986";
                break;
              case "ESP":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ESP.png?13999154437255759986";
                break;
              case "DAT":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/DAT.png?13999154437255759986";
                break;
              case "DPM":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/DPM.png?13999154437255759986";
                break; 
              case "DVS":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/DVS.png?11971926509297675243";
                break;  
              case "EES":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/EES.png?13999154437255759986";
                break; 
              case "ELC":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/ELC.png?13999154437255759986";
                break;
              case "FAN":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/FAN.png?13999154437255759986";
                break;
              case "FLP":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/FLP.png?13999154437255759986";
                break;
              case "GEN":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEN.png?13999154437255759986";
                break;
              case "GEW":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEW.png?13999154437255759986";
                break;
              case "GEWCB":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEWCB.png?13999154437255759986";
                break;
              case "GEWILT":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/GEWILT.png?13999154437255759986";
                break;
              case "H":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/H.png?13999154437255759986";
                break;
              case "HIG":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/HIG.png?13999154437255759986";
                break;
              case "L":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/L.png?13999154437255759986";
                break;
              case "LEG":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/LEG.png?13999154437255759986";
                break;
              case "LIT":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/LIT.png?13999154437255759986";
                break;
              case "M1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/CO1.png?13999154437255759986";
                break;
              case "MET":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/MET.png?13999154437255759986";
                break;
              case "MOT":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/MOT.png?11971926509297675243";
                break;  
              case "OR1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/OR1.png?13999154437255759986";
                break;
              case "P1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/P1.png?13999154437255759986";
                break;
              case "P3":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/P3.png?13999154437255759986";
                break;
              case "P4":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/P4.png?13999154437255759986";
                break;
              case "PM":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/PM.png?13999154437255759986";
                break;
              case "PRO":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/PRO.png?13999154437255759986";
                break;
              case "Q":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/Q.png?13999154437255759986";
                break;
              case "R":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/R.png?13999154437255759986";
                break;  
              case "RE1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/RE1.png?13999154437255759986";
                break;
              case "RHE":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/RHE.png?13999154437255759986";
                break;
              case "RHS":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/RHS.png?13999154437255759986";
                break; 
              case "SCA":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SCA.png?13999154437255759986";
                break;
              case "SEC":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SEC.png?13999154437255759986";
                break;
              case "SM1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SM1.png?13999154437255759986";
                break;
              case "SM2":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SM2.png?13999154437255759986";
                break;
              case "SOL":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SOL.png?13999154437255759986";
                break;
              case "SOL2":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SOL2.png?13999154437255759986";
                break;
              case "SOLSAV":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/SOLSAV.png?11971926509297675243";
                break;  
              case "T":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/T.png?13999154437255759986";
                break;
              case "T1":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/T1.png?13999154437255759986";
                break;
              case "T2":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/T2.png?13999154437255759986";
                break;
              case "TC":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/TC.png?13999154437255759986";
                break;
              case "TEC":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/TEC.png?13999154437255759986";
                break;
              case "TS":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/TS.png?13999154437255759986";
                break;
              case "U":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/U.png?13999154437255759986";
                break;
              case "U2":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/U2.png?13999154437255759986";
                break;
              case "WIR":
                var CatImage  = "https://cdn.shopify.com/s/files/1/1284/8335/files/WIR.png?13999154437255759986";
                break;
            }
            //BUILD NEW OBJECT FOR MUSTACHE TEMPLATE
            var NewData = { 
              title: data.price[0].ProductId,
              productLink: removeSKUslash(data.price[0].ProductId),
              discription: data.price[0].Discription,
              price: listPrice,
              imageLink : PicLink,
              shopifyProdID : data.price[0].ShopifyProductID,
              shopifyVarID : data.price[0].ShopifyVariantID,
              discount : data.discount[0].Discount + "%",
              stockLM : data.stock["Long Meadow"],
              stockGS : data.stock["Germiston"],
              stockPT : data.stock["Pinetown"],
              stockRH : data.stock["Riverhorse"],
              stockCT : data.stock["Cape Town"],
              certLink : CertLink,
              specLink : SpecLink,
              savePrice : saving,
              netPrice : nettPrice,
              categoryImage : CatImage,
            }

            $('.loading-image-shodow').hide();

            /*============================================================================================*/
            /*  COOKIE TO SEE WHETHER THE CUSTOMER HAS SELECTED TO TURN OFF IMAGES ON ACC INFO PAGE       */
            /*============================================================================================*/

            function checkImageCookie() {
              var show_image_selected = getCookie("displayProductImages");
              if (show_image_selected !=="" && show_image_selected !==undefined) {
                if (show_image_selected === "false") {
                  $(".grid-link__image--product").hide();
                  $(".indiItemSearch .one-fifth").hide();
                } else {
                  $(".grid-link__image--product").show();
                  $(".indiItemSearch .one-fifth").show();
                }
              }
            }

            var html = Mustache.to_html(template, NewData);

            //PREPOPULATE NEW TABS THAT WILL BE USED FOR REORDERING ACCORDING TO THE AMMOUNT OF ITEMS ON PAGE

            $("#product_tab_container").append(html);
            counter++;
            if(counter == searchdata.sku.length) {
              //SORT PRODUCTS ACCORDING TO SORT DROPDOWN
              //DEFAULT A-Z
              for(var Q = 0; Q < counter; Q++) {
                var findSKU = searchdata.sku[Q];
                for(var P = 0; P < counter; P++) {  
                  $(".prodTAb").each(function() {
                    var currentSKU  = $(this).find(".variant-sku").text();
                    if (findSKU === currentSKU){
                      $($(this).detach()).appendTo(".SQ_" + Q);
                      $(".orderedProduct").addClass("grid__item wide--one-fifth large--one-quarter medium-down--one-half");
                      $(".prodTAb").removeClass("grid__item wide--one-fifth large--one-quarter medium-down--one-half");
                      return false;
                    }
                  });
                  break;
                }
              }

              //console.log('PRODUCT REFRESH TIME:' + ((Date.now() - starttime) / 1000));
              Shopify.AjaxifyCart.init();
              addToFAV();
              checkImageCookie();
              displayRibbons();


              //CERT HAS NO LINK, SHOW POPUP
              $(".TechBlock").on("click", function(){
                if($(this).parent().hasClass('noCert1')){
                  $('.popOverlay').show();
                  $('.popText').show();
                  $('#certSpec').hide();
                  var sku = $('.product-info-code').text();
                  $('#IndiProdID').attr('value',sku);
                }
              });
              //CERT HAS NO LINK, SHOW POPUP
              $('.CertBlock').on('click', function(){
                if($(this).parent().hasClass('noCert2')){
                  $('.popOverlay').show();
                  $('.popText').show();
                  $('#techSpec').hide();
                  var sku = $('.product-info-code').text();
                  $('#IndiProdID').attr('value',sku);
                }
              });

              //MAKE ADJUSTMENTS TO CERT THAT DONT HAVE LINKS
              $(".BlueBlocks").each(function(){
                var emptyHREF = $(this).find('#linkTechSpec').attr('href');
                if(emptyHREF === "") {
                  $(this).find('#linkTechSpec').removeAttr('target');
                  $(this).find('#linkTechSpec').removeAttr('href');
                  $(this).find('#linkTechSpec').addClass('noCert1');
                }
                var emptyHREF2 = $(this).find('#linkProdCert').attr('href');
                if(emptyHREF2 === "") {
                  $(this).find('#linkProdCert').removeAttr('href');
                  $(this).find('#linkProdCert').removeAttr('target');
                  $(this).find('#linkProdCert').addClass('noCert2');
                }
              });

              /*===========================================================================================*/
              /* COMPARE PRODUCTS                                                                          */
              /*===========================================================================================*/

              var compareProduct1Cookie = getCookie("ComparisonOne");
              var compareProduct2Cookie = getCookie("ComparisonTwo");
              var compareArray = [];
              if(compareProduct1Cookie !== "" && compareProduct1Cookie !== undefined){
                compareArray.push(compareProduct1Cookie);
                $(".prodTAb").each(function(){
                  $(this).find(".compareOff").text("Compare to " + compareArray[0]);
                });               
              }
              
              if(compareProduct2Cookie !== "" && compareProduct2Cookie !== undefined){
                compareArray.push(compareProduct2Cookie);
                $(".prodTAb").each(function(){
                  $(this).find(".compareOff").text("Compare to " + compareArray[0]);
                });                 
              }

              $(".prodTAb").each(function(){
                var currentProduct = $(this).find(".variant-sku").text();
                if(compareProduct1Cookie === currentProduct || compareProduct2Cookie === currentProduct){
                  $(this).find(".compare").removeClass("compareOff");
                  $(this).find(".compare").addClass("compareOn");
                  $(this).find(".compare").addClass("activeCompare");
                }
              });

              if(compareArray.length === 2) {
                //WE NOW HAVE 2 PRODUCTS TO COMPARE
                //SO NOW WE CAN DISABLE THE REST OF THE COMPARE SELECTIONS ON OTHER TABS
                //WE DO THIS BY DECREASING THE COMPARE SELECTION'S Z-INDEX TO 9
                //NOEW THE USER CANT SELECT IT BECAUSE OVER TRANSPARENT DIV IS FLAOTING ABOVE IT
                $(".prodTAb").each(function(){
                  $(this).find(".compareOff").hide();
                });
              } 

              $(".compare").click(function() {
                //HAS THIS PRODUCT BEEN SELECTED FOR COMPARISON
                //IF IT HAS A CLASS ACTIVECOMPARE, IT HAS BEEN SELECTED
                if($(this).hasClass("activeCompare")) {
                  //REMOVE PRODUCT FROM COMPARISON
                  $(this).addClass("compareOff");
                  $(this).removeClass("compareOn");
                  $(this).removeClass("activeCompare");
                  //GET SELECTED SKU OF SELECTED PRODUCT
                  var selectedSKU = $(this).siblings().find(".variant-sku").text();
                  //IF SKU IS FOUND IN ARRAY IT WILL HAVE AN INDEXOF VALUE THAT IS GREATER THAN -1 
                  var removeItemIndex = compareArray.indexOf(selectedSKU);
                  if (removeItemIndex > -1) {
                    //WE HAVE FOUND THIS SKU IN THE ARRAY, NOW WE ARE REMOVING 
                    compareArray.splice(removeItemIndex, 1);
                  }
                  console.log(compareArray);
                  //THIS IS NOT AN ACTIVECOMPARISON PRODUCT, BECASUE IT HAS NO ACTIVECOMPARE CLASS
                } else {
                  //ADD PRODUCT FROM COMPARISON
                  $(this).removeClass("compareOff");
                  $(this).addClass("compareOn");
                  $(this).addClass("activeCompare");
                  //GET SELECTED SKU OF SELECTED PRODUCT
                  var selectedSKU = $(this).siblings().find(".variant-sku").text();
                  //ADD SKU TO ARRAY
                  compareArray.push(selectedSKU); 
                  console.log(compareArray);
                }

                //IF ARRAY HAS ANY PRODUCTS TO COMPARE, DISPLAY CONTAINER DIV 
                if(compareArray.length !== 0){
                  $(".compareProductsSection").slideDown();
                  //POPULATE 1ST PRODUCT TO COMPARE INFO PANEL AT THE TOP
                  $(".compareProduct1").text(compareArray[0]);
                  //POPULATE 1ST PRODUCT COOKIE FOR COMPARISON PAGE
                  document.cookie = "ComparisonOne=" + compareArray[0] + ";path=/;";
                  //OUR COMPARISON IS LIMITED 2 ITEMS ONLY
                  console.log(compareArray);
                  if(compareArray.length < 2) {
                    //IF THE 2ND COMPARE PRODUCT HAS NOT BEEN SELECTED WE HAVE DEFAULT PLACE HOLDER OF '-----'
                    $(".compareProduct2").text("-----");
                    document.cookie = "ComparisonTwo=; path=/;";
                    //IF WE DONT HAVE 2 PRODUCTS TO COMPARE, WE CANT DISPLAY THE COMPARE BUTTON 
                    $(".compareButton").hide();
                    //IF WE HAVE MORE THAN 2 PRODUCTS, WE DISABLE THE COMPARE SELECTION
                    //THIS IS DONE BY A TRANSPARENT DIV THAT IS ABOVE THE COMPARE SELECTION DIV
                    $(".prodTAb").each(function(){
                      //HERE WE HAVE ONLY 1 PRODUCT FOR COMPARISON
                      //WE INCREASE THE COMPARE SELECTION'S Z-INDEX TO 11 TON ABLE IT
                      $(this).find(".compareOff").css("z-index","11");
                      $(this).find(".compareOff").css("opacity","1");
                      $(this).find(".compareOff").text("Compare to " + compareArray[0]);
                    });

                  } else {
                    //A 2ND PRODUCT HAS BEEN SELECTED FOR COMPARISON
                    //WE UPDATE THE INFO PANEL AT THE TOP AND POPULETE THE 2ND COOKIE
                    $(".compareProduct2").text(compareArray[1]);
                    document.cookie = "ComparisonTwo=" + compareArray[1] + ";path=/;";
                    //NOW WE CAN DISPLAY THE COMPARE BUTTON
                    $(".compareButton").show();

                    if(compareArray.length === 2) {
                      //WE NOW HAVE 2 PRODUCTS TO COMPARE
                      //SO NOW WE CAN DISABLE THE REST OF THE COMPARE SELECTIONS ON OTHER TABS
                      //WE DO THIS BY DECREASING THE COMPARE SELECTION'S Z-INDEX TO 9
                      //NOW THE USER CANT SELECT IT BECAUSE OVER TRANSPARENT DIV IS FLAOTING ABOVE IT
                      $(".prodTAb").each(function(){
                        $(this).find(".compareOff").css("z-index","9");
                        $(this).find(".compareOff").css("opacity","0.5");
                        //$(this).find(".compareOn").text(compareArray[0] + " vs " + compareArray[1]);                        
                      });
                      window.location.href = "/pages/comparison/";
                    } else {
                      $(this).find(".compareOn").text("Compare to " + compareArray[0]);
                      $(".prodTAb").each(function(){
                        $(this).find(".compareOn").text("Compare");
                      });
                    }
                  }  
                  //ARRAY HAS NO PRODUCTS TO COMPARE, HIDE CONTAINER DIV   
                } else {
                  document.cookie = "ComparisonOne=; path=/;";
                  $(".prodTAb").each(function(){
                    $(this).find(".compareOff").text("Compare");
                  });
                }

                //USER CLICKS ON THE COMPARE BUTTON AND GETS REDIRECTED...
                //...TO COMPARISON PAGE
                $(".compareButton").click(function(){
                  window.location.href = "/pages/comparison/";
                });
              });  

            }
          }).fail(function(err){
            console.log(err);
          });
        } 
      }
    }); 

  }
  /*===========================================================================================*/
  /* PRODUCT FILTER - SAVE COOKIE WHEN SELECTING SAVE AS DEFAULT BUTTON                        */
  /*===========================================================================================*/

  //CHECK TO SEE IF USER HAS SAVED PREVIOUS SEARCH FILTER RESULTS
  function checkFilterSaveCookie() {
    var save_filter_options = getCookie("Searchfilter");
    if (save_filter_options !=="" && save_filter_options !== undefined) {
      //IF THE USER HAS A COOKIE SAVED (THE USER MUST HAVE SELECTED THE SAVE AS DEFAULT BUTTON) SHOW THE RELOAD FILTER BUTTON            
      if ((save_filter_options).length > 0) { 
        $(".reloadFilter").show();  
        var displaySavedSection = getCookie("displaySavedCookie")
        if(displaySavedSection  === "true") {
          $(".savedFilterSection").show(); 
        }
      }
    }
  }
  checkFilterSaveCookie();


  /*IN THIS FUNCTION WE DO THE FOLLOWING:*/ 	
  /*LOOK AT CURRENT URL*/
  /*REMOVE HASH FROM THE URL*/
  /*DECODE THE URL*/
  /*RETURN THE SEARCH FILTER RESULTS*/

  function CheckSelectedCheck() {
    /*LOOK AT THE CURRENT URL*/    
    var product_page_hash = window.location.hash;  
    if(product_page_hash !== "" && product_page_hash !== undefined) { 
      /*REMOVE THE HASH FROM THE URL*/      
      product_page_hash = product_page_hash.substring(1);
      var savedFilter = decodeURL();
      //REMOVE ANY SEARCH TERMS ON SAVING FILTER SELECTION
      filter.search = "";
      savedFilter = filter;
      encodeURL(savedFilter);
      /*DECODE THE URL*/      
      //product_page_hash = atob(product_page_hash);
      /*RETURN THE SEARCH FILTER*/        
      var Searchfilter = product_page_hash;
      /*CREATE A COOKIE WITH THE RETURNED SEARCH RESULTS*/        
      document.cookie = "Searchfilter=" + product_page_hash + "; path=/;"; 
    }
  }

  /*SAVE FILTER OPTIONS BUTTON*/
  $(".defaultFilter").click(function() {  
    document.cookie = "displaySavedCookie=true; path=/;";
    $(".defaultFilter").text("SAVING AS DEFAULT FILTER"); 
    $(".defaultFilter").css("background-color","#0070ba");
    $(".defaultFilter").css("color","#fff");
    setTimeout(function(){
      $(".defaultFilter").text("DONE!"); 
    },3000);
    setTimeout(function(){
      $(".defaultFilter").text("SAVE AS DEFAULT FILTER");  
      $(".defaultFilter").css("background", "transparent");
      $(".defaultFilter").css("color","#0070ba");
    }, 5000);
    /*CALLING THE FUNCTION THAT LOOKED AT THE PREVIOUS SAVED SEARCH*/
    CheckSelectedCheck();  
  });




  /*===========================================================================================*/
  /* PRODUCT FILTER - CHECK WHAT CATEGORIES PRODUCTS ARE PICKED IN CATEGORIES AND ONLY DISPLAY THOSE BRAND    */
  /*===========================================================================================*/
  function checkBrand(catSelect) {
    if($("#" + catSelect + "_input").prop('checked') == false) {
      //IF CHECKED, SHOW EVERYTHING AGAIN
      alreadyFiltering = false;

      $('#catScript').find(".typeDiv").hide();
      $('#catScript').find(".smallSqueeze").hide();

      //REMOVE CATEGORIES
      $('#catScript').each(function() {
        //CHECK FOR BRAND S WITH MULTIPLE VENDORS
        //RHOMBERG -> ACD300, ACD304
        //TERASAKI -> TER400, TER401
        //UNITRONICS -> UNI400, VIS300
        //VACON -> VAC400, VAC401, VAC402
        //ISKA -> ISK400, ISK401
        if (catSelect === "ISKA") {
          var itemtoRemove = "ISK400";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1); 
          var itemtoRemove = "ISK401";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1); 
        } else if (catSelect === "RHOMBERG") {
          var itemtoRemove = "ACD300";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
          var itemtoRemove = "ACD304";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1); 
        } else if (catSelect === "TERASAKI") {
          var itemtoRemove = "TER400";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
          var itemtoRemove = "TER401";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
        } else if (catSelect === "UNITRONICS") {
          var itemtoRemove = "UNI400";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
          var itemtoRemove = "VIS300";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
        } else if (catSelect === "VACON") {
          var itemtoRemove = "VAC400";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
          var itemtoRemove = "VAC401";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
          var itemtoRemove = "VAC402";
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
        } else {
          var itemtoRemove = catSelect;
          filter.brand.splice($.inArray(itemtoRemove ,filter.brand),1);
        }         

        $.ajax({ 
          url: integrationURL + 'products/search/1/1',
          type: 'post',
          data: JSON.stringify(filter),
          headers: {
            "Content-Type" : 'application/json'
          }
        }).done(function(data) {

          if (filter.brand.length === 0 && filter.category.length === 0) {
            $('#brandScript').find(".smallSqueeze").show();
            $('#catScript').find(".typeDiv").show();
            $('#catScript').find(".smallSqueeze").hide();
            $('#catScript').find(".smallSqueeze").css("height","18px");
            $('#catScript').find(".minusClass").addClass('plusClass');
            $('#catScript').find(".minusClass").removeClass('minusClass');
          } 

          for(var i = 0; i < data.categories.length; i++) {
            var catDATA = data.categories[i];
            $('#catScript').find("#" + catDATA + "_input").parent().parent().parent().show();
            $('#catScript').find("#" + catDATA + "_input").parent().show();
            $('#catScript').find(".minusClass").addClass('plusClass');
            $('#catScript').find(".minusClass").removeClass('minusClass');

            $('#catScript').find(".typeDiv").show();
            $('#catScript').find(".smallSqueeze").show();
          }
        });
      });

    } else {   
      //IF NOT CHECKED, HIDE EVERYTHING
      alreadyFiltering = true;
      $('#catScript').find(".typeDiv").hide();
      $('#catScript').find(".smallSqueeze").hide();

      //DISPLAY SELECTED CATEGORIES
      $('#catScript').each(function() {
        //CHECK FOR BRAND S WITH MULTIPLE VENDORS
        //RHOMBERG -> ACD300, ACD304
        //TERASAKI -> TER400, TER401
        //UNITRONICS -> UNI400, VIS300
        //VACON -> VAC400, VAC401, VAC402
        //ISKA -> ISK400, ISK401
        if (catSelect === "ISKA") {
          filter.brand.push("ISK400","ISK401");          
        } else if (catSelect === "RHOMBERG") {
          filter.brand.push("ACD300","ACD304");          
        } else if (catSelect === "TERASAKI") {
          filter.brand.push("TER400","TER401");
        } else if (catSelect === "UNITRONICS") {
          filter.brand.push("UNI400","VIS300");
        } else if (catSelect === "VACON") {
          filter.brand.push("VAC400","VAC401","VAC402");
        } else {
          filter.brand.push(catSelect);
        } 

        $.ajax({ 
          url: integrationURL + 'products/search/1/1',  
          type: 'post',
          data: JSON.stringify(filter),
          headers: {
            "Content-Type" : 'application/json'
          }
        }).done(function(data) {
          for(var i = 0; i < data.categories.length; i++) {
            var catDATA = data.categories[i];
            //filter.category.push(catDATA);
            $('#catScript').find("#" + catDATA + "_input").parent().parent().parent().show();
            $('#catScript').find("#" + catDATA + "_input").parent().show();
            //$('#catScript').find("#" + catDATA + "_input").prop('checked', true );
            $('#catScript').find(".minusClass").addClass('plusClass');
            $('#catScript').find(".minusClass").removeClass('minusClass');
            //$('#catScript').find("#" + catDATA + "_input").siblings().addClass("radioOn");
            //$('#catScript').find("#" + catDATA + "_input").siblings().removeClass("radioOff");

          }

        });
      });
    }
    console.log("CatUpdate Filter Add: " + JSON.stringify(filter));
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  }

  /*===========================================================================================*/
  /* PRODUCT FILTER - CHECK WHAT BRAND PRODUCTS ARE PICKED IN BRANDS AND ONLY DISPLAY THOSE CATEGORIES        */
  /*===========================================================================================*/
  function checkCat(selectBrand){ 
    if($("#" + selectBrand + "_input").prop('checked') == false) {
      alreadyFiltering = false;
      $('#brandScript').find(".smallSqueeze").hide();
      //DISPLAY SELECTED BRANDS
      $('#brandScript').each(function() {
        var itemtoRemove = selectBrand;
        filter.category.splice($.inArray(itemtoRemove ,filter.category),1);
        $.ajax({ 
          url: integrationURL + 'products/search/1/1',  
          type: 'post',
          data: JSON.stringify(filter),
          headers: {
            "Content-Type" : 'application/json'
          }
        }).done(function(data) {
          //IF NOTHING IS CHECKED, SHOW EVERYTHING AGAIN
          if (data.categories.length > 0 ) {
            for(var i = 0; i < data.brands.length; i++) {              
              var brandDATA = removeBrandchars(data.brands[i]);
              $('#brandScript').find("#" + brandDATA + "_input").parent().show();
              $('#brandScript').find(".minusClass").addClass('plusClass');
              $('#brandScript').find(".minusClass").removeClass('minusClass');
            }
          } else {
            $('#brandScript').find(".smallSqueeze").hide();
          }
        });
      });
    } else {
      //IF NOT CHECKED, HIDE EVERYTHING
      alreadyFiltering = true;
      $('#brandScript').find(".smallSqueeze").hide();
      //DISPLAY SELECTED BRANDS
      $('#brandScript').each(function() {
        filter.category.push(selectBrand);
        $.ajax({ 
          url: integrationURL + 'products/search/1/1',  
          type: 'post',
          data: JSON.stringify(filter),
          headers: {
            "Content-Type" : 'application/json'
          }
        }).done(function(data) {
          for(var i = 0; i < data.brands.length; i++) {
            var brandDATA = removeBrandchars(data.brands[i]);
            $('#brandScript').find("#" + brandDATA + "_input").parent().show();
            $('#brandScript').find(".minusClass").addClass('plusClass');
            $('#brandScript').find(".minusClass").removeClass('minusClass');
          }        

        });

      });
    }
    console.log("Cate Filter: " + JSON.stringify(filter));
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  }

  /*===========================================================================================*/
  /* PRODUCT FILTER - RELOAD COOKIE WHEN SELECTING THE RELOAD BUTTON ON THE PRODUCT FILTER     */
  /*===========================================================================================*/

  /*RELOAD FILTER OPTIONS BUTTON*/
  $(".reloadFilter").click(function() { 
    document.cookie = "displaySavedCookie=false; path=/;";
    /*CALLING THE COOKIE THAT HAS STORED THE SAVED SEARCH RESULTS*/
    var SavedFilter = getCookie("Searchfilter");
    /*CALLING THE FUNCTION THAT REBUILDS THE FILTER WITH THE PREVIOUS SEARCH RESULTS NOW SHOWING*/ 
    window.location.href = "#" + SavedFilter;
    location.reload();
  });


  $(".savedFilterYes").click(function() { 
    document.cookie = "displaySavedCookie=false; path=/;";
    /*CALLING THE COOKIE THAT HAS STORED THE SAVED SEARCH RESULTS*/
    var SavedFilter = getCookie("Searchfilter");
    /*CALLING THE FUNCTION THAT REBUILDS THE FILTER WITH THE PREVIOUS SEARCH RESULTS NOW SHOWING*/ 
    $(".savedFilterSection").slideUp();
    window.location.href = "#" + SavedFilter;
    location.reload();
  });

  $(".savedFilterNo").click(function() { 
    $(".savedFilterSection").slideUp();
    document.cookie = "displaySavedCookie=false; path=/;";
  }); 


  /*===========================================================================================*/
  /* PRODUCT FILTER - UPDATE FILTER SEARCH BUTTON                                              */
  /*===========================================================================================*/
  function UpdateFilter() {
    $('.loading-image-shodow').show();
    var search_lookup = $("#ProdSearch").val();

    //GET HASH FROM URL AND DECODE IT
    //IF WE HAVE HASH, UPDATE THE FILTER WITH THIS FILTER OBJECT
    //IF NOT, DO NOTHING
    var HAShash = decodeURL();    
    if(HAShash !== "" && HAShash !== undefined) {
      //console.log("HASH value: " + HAShash);
      var hashfilter = JSON.parse(HAShash);
      //UpdateFilterCheckBoxes(hashfilter);
      filter = hashfilter;
    } else {
      filter =  initialiseFilter();
    }

    filter.search = removeSKUslash(search_lookup);    

    //WE ARE PERFORMING AN ACTIVE SEACH, CHANGE ACTIVE SEARCH VAR TO TRUE
    activeSearch = "true";
    /*
    document.cookie = "activeSearchCookie=true; path=/";
    MinpriceFilter = parseFloat($(".low-range-clean").text());
    MAXpriceFilter = parseFloat($(".high-range-clean").text());
    filter.price = [];
    filter.price.push(MinpriceFilter, MAXpriceFilter);
    */
    encodeURL(filter);
    //console.log("After adding other stuff" + JSON.stringify(filter));
    productInfomation(default_page_no,default_items_per_page,filter);
  }

  /*===========================================================================================*/
  /* PRODUCT FILTER - FILTER SEARCH                                                            */
  /*===========================================================================================*/
  //PRODUCT PAGE SEARCH ON LEFT

  function searchBarLeft() {
    $(".activeFilterCriteria").show();
    $('.loading-image-shodow').show();
    var search_lookup = $("#ProdSearch").val();
    var newfilter = initialiseFilter();
    newfilter.search = removeSKUslash(search_lookup);
    encodeURL(newfilter);
    productInfomation(default_page_no, default_items_per_page, newfilter);
    //WE ARE PERFORMING AN ACTIVE SEACH, CHANGE ACTIVE SEARCH VAR TO TRUE
    activeSearch = "true";
    document.cookie = "activeSearchCookie=true; path=/";   
  }

  var isKeyPress;

  $("#ProdSearch").keypress(function(e){  
    if(e.which == 13) {   
      $(".activeFilterCriteria").show();
      //ENTER KEY PRESSED
      //searchBarLeft();
      e.preventDefault();
      isKeyPress = true;
      UpdateFilter();      
      searchFilterDisplay();      
    }
  });


  $("#prodSearchBtn").click(function() {
    //MOUSE CLICK
    $(".activeFilterCriteria").show();
    if (!isKeyPress) {   
      UpdateFilter();
      searchFilterDisplay();      
    }
    isKeyPress = false;
  });

  /*===========================================================================================*/
  /*  ADVANCED SEARCH - SEARCH BY                                                              */
  /*===========================================================================================*/

  $(".searchSkuOnly").on( "click", function() {
    filter.searchSKU = "true";
    filter.searchDiscription = "false";
    $(".searchByReplace").text(" by item number");
    $(".searchByReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".searchDescriptionOnly").removeClass("radioOn");
    $(".searchBoth").removeClass("radioOn");
    $(".searchDescriptionOnly").addClass("radioOff");
    $(".searchBoth").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  $(".searchDescriptionOnly").on( "click", function() {
    filter.searchSKU = "false";
    filter.searchDiscription = "true";
    $(".searchByReplace").text(" by item description ");
    $(".searchByReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".searchSkuOnly").removeClass("radioOn");
    $(".searchBoth").removeClass("radioOn");
    $(".searchSkuOnly").addClass("radioOff");
    $(".searchBoth").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  $(".searchBoth").on( "click", function() {
    filter.searchSKU = "false";
    filter.searchDiscription = "false";
    $(".searchByReplace").text(" by item number & item description");
    $(".searchByReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".searchDescriptionOnly").removeClass("radioOn");
    $(".searchSkuOnly").removeClass("radioOn");
    $(".searchDescriptionOnly").addClass("radioOff");
    $(".searchSkuOnly").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /*  ADVANCED SEARCH - LOOK FOR TERMS THAT                                                    */
  /*===========================================================================================*/

  $(".searchStartsWith").on( "click", function() {
    filter.contains = "false";
    filter.startsWith = "true";
    $(".searchTermReplace").text(" that start with");
    $(".searchTermReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".searchContains").removeClass("radioOn");
    $(".searchContains").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  $(".searchContains").on( "click", function() {
    filter.contains = "true";
    filter.startsWith = "false";
    $(".searchTermReplace").text(" that contain");
    $(".searchTermReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".searchStartsWith").removeClass("radioOn");
    $(".searchStartsWith").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /*  ADVANCED SEARCH - INCLUDE                                                            */
  /*===========================================================================================*/  

  $(".priceSpecial").on( "click", function() {
    filter.special.push(1);
    filter.clearance = [];
    $(".searchIncludeReplace").text(" products on special only");
    $(".searchIncludeReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".priceAll").removeClass("radioOn");
    $(".priceAll").addClass("radioOff");
    $(".priceClearance").removeClass("radioOn");
    $(".priceClearance").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  $(".priceClearance").on( "click", function() {
    filter.clearance.push(1);
    filter.special = [];
    $(".searchIncludeReplace").text(" products on clearance only");
    $(".searchIncludeReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".priceAll").removeClass("radioOn");
    $(".priceAll").addClass("radioOff");
    $(".priceSpecial").removeClass("radioOn");
    $(".priceSpecial").addClass("radioOff");
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  $(".priceAll").on( "click", function() {
    filter.clearance = [];
    filter.special = [];
    $(".searchIncludeReplace").text(" all products");
    $(".searchIncludeReplace").css("color","#0070ba");
    $(this).addClass("radioOn");
    $(this).removeClass("radioOff");
    $(".priceSpecial").removeClass("radioOn");
    $(".priceSpecial").addClass("radioOff");
    $(".priceClearance").removeClass("radioOn");
    $(".priceClearance").addClass("radioOff"); 
    searchFilterDisplay()
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /*  ADVANCED SEARCH - PRICE RANGE - CHECKBOXES                                               */
  /*===========================================================================================*/ 
  /*
  //THIS IS TEMP NEEDS TO BE REMOVED
  $(".hideLink").on( "click", function() {
    $(".moreRangeOptions").show();  
  });

  var selectedMinCombo = 0;
  var selectedMaxCombo = 0;
  var selectedRangeComboMax = 0;
  var selectedRangeComboMin = 0;
  var firstCheck = true;
  var minArray = new Array();
  var maxArray = new Array();
  var priceCheckboxArray = new Array();

  function priceRange() {  
    var minTempArray = new Array();
    var maxTempArray = new Array();
    var priceCheckboxTempArray = new Array();
    $(".priceCheckbox").each(function() {

      if($(this).is(':checked')) {
        //GET SELECTED VALUES AND STORE IN ARRAY
        var selectedMin = parseFloat($(this).attr('data-minlimit'));
        var selectedMax = parseFloat($(this).attr('data-maxlimit'));

        var selectedID = $(this).attr('id');
        var detectRange = parseInt(selectedID.substring(10));
        priceCheckboxTempArray.push(detectRange);

        minTempArray.push(selectedMin);
        maxTempArray.push(selectedMax);
      }
    });


    //REMOVE DUPLICATES FROM MIN ARRAY
    var minArray = [];
    $.each(minTempArray, function(i, el){
      if($.inArray(el, minArray) === -1) minArray.push(el);
    });

    //REMOVE DUPLICATES FROM MAX ARRAY
    var maxArray = [];
    $.each(maxTempArray, function(i, el){
      if($.inArray(el, maxArray) === -1) maxArray.push(el);
    });

    //REMOVE DUPLICATES FROM RANGE ARRAY
    var priceCheckboxArray = [];
    $.each(priceCheckboxTempArray, function(i, el){
      if($.inArray(el, priceCheckboxArray) === -1) priceCheckboxArray.push(el);
    });



    //DETERMINE MIN AND MAX RANGE FROM SELECTED VALUES
    selectedMaxCombo = Math.max.apply(Math,maxArray);
    selectedMinCombo = Math.min.apply(Math,minArray);
    selectedRangeComboMin = Math.min.apply(Math,priceCheckboxArray); 
    selectedRangeComboMax = Math.max.apply(Math,priceCheckboxArray);

    //CHECK ALL BOXES BETWEEN MIN AND MAX PRICE RANGE
    $(".priceCheckbox").each(function() {
      for (var i = selectedRangeComboMin; i <= selectedRangeComboMax; i++ ) {
        $("#priceRange" + i).prop('checked', true);
      }
    });

    //NOTE - IF SLIDER IS USED AFTER CHECKBOX SELECTION
    //IT WILL UPDATE THE FILTER VALUES WITHIN THE SELECTED CHECKBOX RANGE

    $(".low-range").text(formatMoney(selectedMinCombo));
    $(".low-range-clean").text(selectedMinCombo);

    //IF HIGHEST RANGE IS SELECTED, UPDATE PRICE RANGE SLIDER WITH MAX LIMIT
    if($.inArray(9, priceCheckboxArray) === -1) {
      $(".high-range").text(formatMoney(selectedMaxCombo));
      $(".high-range-clean").text(selectedMaxCombo);
      $(".low-range").text(formatMoney(selectedMinCombo));
      $(".low-range-clean").text(selectedMinCombo);
      initPriceSlider(selectedMinCombo,selectedMaxCombo);
    } else {
      $(".high-range").text(formatMoney(MAXpriceLimit));
      $(".high-range-clean").text(MAXpriceLimit);
      $(".low-range").text(formatMoney(selectedMinCombo));
      $(".low-range-clean").text(selectedMinCombo);
      initPriceSlider(selectedMinCombo,MAXpriceLimit);
    }

    //IF NO CHECKBOXES ARE SELECTED RESET SLIDER TO DEFAULT VALUES
    if(priceCheckboxArray.length === 0) {
      $(".high-range").text(formatMoney(MAXpriceLimit));
      $(".high-range-clean").text(MAXpriceLimit);
      $(".low-range").text(formatMoney(0.00));
      $(".low-range-clean").text(0.00);
      //initPriceSlider(0.00,MAXpriceLimit);
    }

  }



  //ON CHECKBOX CLICK LOOP ALL CHECKBOXES TO SEE WHAT HAS BEEN CHECKED
  $(".priceCheckbox").click(function() {
    priceRange();      
  });

  //ON CHECKBOX TITLE CLICK LOOP ALL CHECKBOXES TO SEE WHAT HAS BEEN CHECKED
  $(".advancedFilterPriceTitle").click(function() {
    if(!$(this).siblings().is(':checked')) {
      $(this).siblings().prop("checked", true);
      priceRange(); 
    } else {
      $(this).siblings().prop("checked", false);
      priceRange();
    }
  });

  //ON PRICE RANGE SLIDER MOUSEUP, CHECK IF WE HAVE MOVED OUT OF THE SELECTED CHECKBOX RANGE
  $(".low").mouseup(function() {
    var cleanP = $(".low-range-clean").text()
    if (cleanP < selectedMinCombo ) {
      $(".priceCheckbox").each(function() {
        for (var i = selectedRangeComboMin; i <= selectedRangeComboMax; i++ ) {
          $("#priceRange" + i).prop('checked', false);
        }
      });
    }
  });

  $(".high").mouseup(function() {
    var cleanP = $(".high-range-clean").text()
    if (cleanP > selectedMaxCombo ) {
      $(".priceCheckbox").each(function() {
        for (var i = selectedRangeComboMin; i <= selectedRangeComboMax; i++ ) {
          $("#priceRange" + i).prop('checked', false);
        }
      });
    }
  });
   */ 
  /*===========================================================================================*/
  /* UPDATE FILTER ON CLICK                                                                    */
  /*===========================================================================================*/ 
  /*
  $(".advancedFilterInfoTitle").on( "click", function() {
    $(this).siblings().prop("checked", true)

    var siblingID = $(this).siblings().attr('id');
    switch(siblingID) {
      case "priceAll" :
        filter.clearance = [];
        filter.special = [];
        searchFilterDisplay()
        encodeURL(filter);
        break;

      case "priceClearance" :
        filter.clearance.push(1);
        filter.special = [];
        searchFilterDisplay()
        encodeURL(filter);
        break;

      case "priceSpecial" :
        filter.special.push(1);
        filter.clearance = [];
        searchFilterDisplay()
        encodeURL(filter);
        break;

    }

  })
  */
  //PRODUCT PAGE SEARCH ON LEFT
  $(".AdvUpdFilter").click(function() {
    UpdateFilter()
  });


  /*===========================================================================================*/
  /* PRODUCT FILTER - CLEAR FILTER                                                             */
  /*===========================================================================================*/  
  $('#clearFilter').click(function() { 
    //DONT KNOW IF THIS FUNCTION IS STILL BEING USED 

    //CLEAR ALL CHECKBOXES
    $("#catScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.typeTitle').removeClass("radioOn");
        $(this).find('.typeTitle').addClass("radioOff");
      }
    });

    $("#brandScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.brandInfoTitle').removeClass("radioOn");
        $(this).find('.brandInfoTitle').addClass("radioOff");
      }
    });
    document.cookie = "activeSearchCookie=false; path=/";
    var cleanFilter = initialiseFilter();
    encodeURL(cleanFilter);
    window.location = "https://new.acdc.co.za/pages/all-products";

  });

  $('#advancedClearFilter').click(function() { 
    //CLEAR ALL CHECKBOXES
    $("#catScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.typeTitle').removeClass("radioOn");
        $(this).find('.typeTitle').addClass("radioOff");
        $("#viewAllCatTab").find('#Dci_title').addClass("radioOn");
      } 
    });

    $("#brandScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.brandInfoTitle').removeClass("radioOn");
        $(this).find('.brandInfoTitle').addClass("radioOff");
        $("#viewAllTab").find('#Dbi_title').addClass("radioOn");
      }
    });
    document.cookie = "activeSearchCookie=false; path=/";
    var cleanFilter = initialiseFilter();
    encodeURL(cleanFilter);
    location.reload();

  });

  /*===========================================================================================*/
  /* PRODUCT FILTER - USER CLICKS ON CHECKBOXES                                               */
  /*===========================================================================================*/
  $('.openerCheck').click(function() {
    /*
    // create empty filter object
    var newfilter = initialiseFilter();

    var allFilterCheckBoxes = $('.openerCheck');

    var typeSelect = $(this).attr('data-filtertype');
    var valueSelect = $(this).attr('data-filtervalue');


    //iterate over all .openerCheck
    allFilterCheckBoxes.each(function( index ) {
      var filterType = $(this).attr('data-filtertype');
      var filterValue = $(this).attr('data-filtervalue');

      if($(this).is(':checked')) {
        switch(filterType) {
          case 'brand' : 
            if (product_page_url == "/pages/products-specials"){
              newfilter.special.push(1);
              checkBrand(valueSelect);
            } else {
              checkBrand(valueSelect);
            }

            break;   
          case 'category' :  
            if (product_page_url == "/pages/products-specials"){
              newfilter.special.push(1);
              checkCat(valueSelect);
            } else {
              checkCat(valueSelect);
            }
            break;          
        } 
      } else {

      }

      if(!$(this).is(':checked')) {
        //productInfomation(default_page_no, default_items_per_page, newfilter);  
      }
    });
    document.cookie = "activeSearchCookie=false; path=/"; 
    */
  });

  /*===========================================================================================*/
  /* SPECIALS AND CLEARANCE TAB CLICKS AND HOVER FUNCTIONS                                     */
  /*===========================================================================================*/   
  //THIS HAS BEEN REOMED ON THE FRONT END ON MARCO'S REQUEST
  $("#specialsTab").click(function() {
    filter.special.push(1);
    filter.clearance = [];
    $("#specialsTab").find(".catProdTabTitle").addClass("activeTab");
    $("#clearanceTab").find(".catProdTabTitle").removeClass("activeTab");
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  $("#clearanceTab").click(function() {
    filter.clearance.push(1);
    filter.special = [];
    $("#specialsTab").find(".catProdTabTitle").removeClass("activeTab");
    $("#clearanceTab").find(".catProdTabTitle").addClass("activeTab");
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /* PRODUCT FILTER - USER CLICKS TO TO VIEW ALL CATEGORIES                                    */
  /*===========================================================================================*/

  $("#Dbi_title").click(function() {
    $("#brandScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.brandInfoTitle').removeClass("radioOn");
        $(this).find('.brandInfoTitle').addClass("radioOff");
        $(this).find('#Dbi_title').addClass("radioOn");
      }
    }); 
    $(this).parent().parent().parent().find(".catInfoTitle").css("color","#666");

    $('#brandScript').find(".smallSqueeze").show();
    $('#catScript').find(".smallSqueeze").show();
    $("#catScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.typeTitle').removeClass("radioOn");
        $(this).find('.typeTitle').addClass("radioOff");
        $("#viewAllCatTab").find('#Dci_title').addClass("radioOn");
      } 
    });

    filter.brand=[];
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /* PRODUCT FILTER - USER CLICKS TO TO VIEW ALL CATEGORIES                                    */
  /*===========================================================================================*/   
  $("#Dbi_title").click(function() {
    $("#brandScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find('.brandInfoTitle').removeClass("radioOn");
        $(this).find('.brandInfoTitle').addClass("radioOff");
        $(this).find('#Dbi_title').addClass("radioOn");
        $(this).find('#Dbi_title').removeClass("radioOff");
      }
    }); 
    $(this).parent().parent().parent().find(".catInfoTitle").css("color","#666");

    $('#brandScript').find(".smallSqueeze").show();
    $('#catScript').find(".smallSqueeze").show();
    $("#catScript").each(function() {
      $(this).find(".smallSqueeze").css("height","18px");
      $(this).find(".typeDiv").show();
    });

    filter.brand=[];
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /* PRODUCT FILTER - USER CLICKS TO TO VIEW ALL BRANDS                                    */
  /*===========================================================================================*/  
  $("#Dci_title").click(function() {
    $("#catScript").each(function() {
      if($(".openerCheck").is(':checked')) {
        $(".openerCheck").prop('checked', false);
        $(this).find(".smallSqueeze").css("height","18px");
        $(this).find(".typeDiv").show();
        $(this).find('.typeTitle ').removeClass("radioOn");
        $(this).find('.typeTitle ').addClass("radioOff");
        $(this).find('#Dci_title').addClass("radioOn");
        $(this).find('#Dci_title').removeClass("radioOff");        
      }
    }); 
    $(this).parent().parent().parent().find(".catProdTabTitle").css("color","#666");

    $("#brandScript").each(function() {
      $(this).find(".smallSqueeze").show();
    });

    filter.category=[];
    encodeURL(filter);
    productInfomation(default_page_no,default_items_per_page,filter);
  });

  /*===========================================================================================*/
  /* PRODUCT FILTER - USER CLICKS CATEGORY TITLES                                              */
  /*===========================================================================================*/ 
  $('.typeTitle').click(function() {
    var HAShash = decodeURL();   
    if(HAShash !== "" && HAShash !== undefined) {
      //console.log("HASH value: " + HAShash);
      var hashfilter = JSON.parse(HAShash);
      //UpdateFilterCheckBoxes(hashfilter);
      filter = hashfilter;
    } 

    var typeSelect = $(this).siblings().attr('data-filtertype');
    var valueSelect = $(this).siblings().attr('data-filtervalue');
    // create empty filter object

    var allFilterCheckBoxes = $(this).siblings();
    if(allFilterCheckBoxes.prop('checked')) {
      allFilterCheckBoxes.prop('checked', false);
      $(this).addClass("radioOff");
      $(this).removeClass("radioOn");
    } else {
      allFilterCheckBoxes.prop('checked', true);
      $(this).removeClass("radioOff");
      $(this).addClass("radioOn");
    }

    // iterate over all .openerCheck
    allFilterCheckBoxes.each(function( index ) {
      //var filterType = $(this).attr('data-filtertype');
      //var filterValue = $(this).attr('data-filtervalue');	
      checkCat(valueSelect);

      if(index == allFilterCheckBoxes.length-1) {

      }

    });
    document.cookie = "activeSearchCookie=false; path=/"; 

  });

  /*===========================================================================================*/
  /* PRODUCT FILTER - USER CLICKS BRAND TITLES                                                 */
  /*===========================================================================================*/  
  $('.brandInfoTitle').click(function() {

    var HAShash = decodeURL();   
    if(HAShash !== "" && HAShash !== undefined) {
      //console.log("HASH value: " + HAShash);
      var hashfilter = JSON.parse(HAShash);
      //UpdateFilterCheckBoxes(hashfilter);
      filter = hashfilter;
    }     

    var typeSelect = $(this).siblings().attr('data-filtertype');
    var valueSelect = $(this).siblings().attr('data-filtervalue');
    //newfilter.search = $('#prodSearch').val();
    var allFilterCheckBoxes = $(this).siblings();

    var selectedBrandBoxes = "";
    if(allFilterCheckBoxes.prop('checked')) {
      allFilterCheckBoxes.prop('checked', false);
      $(this).addClass("radioOff");
      $(this).removeClass("radioOn");
    } else {
      allFilterCheckBoxes.prop('checked', true);
      $(this).removeClass("radioOff");
      $(this).addClass("radioOn");
    }

    // iterate over all .openerCheck
    allFilterCheckBoxes.each(function( index ) {
      var filterType = $(this).attr('data-filtertype');
      var filterValue = $(this).attr('data-filtervalue');	
      checkBrand(valueSelect);

    });

    document.cookie = "activeSearchCookie=false; path=/"; 
  });

  /*===========================================================================================*/
  /* LOAD TEMPLATE                                                                             */
  /*===========================================================================================*/
  // Get product item template once
  var template = $('#productTemplate').html();

  //LOAD TEMPLATE FOR THE FIRST TIME ONCE
  //ALL OTHER LOADS REQUIRE A TRIGGER EVENT, LIKE AN ON CLICK
  //BELOW IF STATEMENT WILL PREVENT A DOUBLE LOAD
  if(freshload) {
    productInfomation(default_page_no, default_items_per_page, filter); 
  }

  if (default_items_per_page === '24') {
    $('#numberOfProducts :nth-child(2)').prop('selected', true);  
    setTimeout(function() {
      $('.wide--one-fifth').each(function() {
        $(this).removeClass("theThreePrincipal");
        $(this).removeClass("theFourPrincipal");
        $(this).removeClass("theEightPrincipal");
        $(this).addClass("theSixPrincipal");
      });      
    }, 3300);       
  } else if (default_items_per_page === '40') {
    $('#numberOfProducts :nth-child(3)').prop('selected', true); 
    setTimeout(function() {
      $('.wide--one-fifth').each(function() {
        $(this).removeClass("theThreePrincipal");
        $(this).removeClass("theFourPrincipal");
        $(this).removeClass("theSixPrincipal");
        $(this).addClass("theEightPrincipal");
      }); 
    }, 3300);
  } else {
    $('#numberOfProducts :nth-child(1)').prop('selected', true);   
    setTimeout(function() { 
      $('.wide--one-fifth').each(function() {
        $(this).removeClass("theThreePrincipal");
        $(this).removeClass("theSixPrincipal");
        $(this).removeClass("theEightPrincipal");
        $(this).addClass("theFourPrincipal");
      }); 
    }, 3300);     
  }

  /*===========================================================================================*/
  /* PRODUCTS PER PAGE COOKIE                                                                  */
  /*===========================================================================================*/
  $("#numberOfProducts").change(function() {
    var thisValue = $(this).val();
    document.cookie = "default_items_per_page=" + thisValue;
    location.reload();
  });

  /*===========================================================================================*/
  /* ORDER BY DROPDOWN FUNCTION                                                                */
  /*===========================================================================================*/
  $("#sortByList").change(function() {
    var selectedSortBy = $(this).val();
    filter.orderBy = selectedSortBy;
    encodeURL(filter);
    productInfomation(default_page_no, default_items_per_page, filter); 
  }); 




});
